module.exports = __webpack_public_path__ + "static/google_store_badge-3d271cae6e86a42f7899220626eac6c9.svg";